// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".show-more__toggle{display:inline-block;-webkit-appearance:none;-moz-appearance:none;appearance:none;border:0;background:transparent;padding:0;font-weight:700;cursor:pointer}", ""]);
// Exports
module.exports = exports;
